import type { PriceUnitDto } from '@/api';
import CombinedCombobox from '@/components/combobox/combined-combobox';
import type { DefaultOptionType } from '@/components/combobox/combobox';
import {
  useFilteredPriceUnits,
  usePriceUnitsPasting,
} from '@/components/combobox/combobox-queries';
import type { MultiValue } from 'chakra-react-select';
import PriceUnitCategoryDropdown from './price-unit-category-dropdown';

type PriceUnitSelectionProps = {
  selectedCategory: string;
  onCategoryChange: (value: string) => void;
  selectedPriceUnits: DefaultOptionType[];
  onPriceUnitsChange: (items: DefaultOptionType[]) => void;
  setHasError: (hasError: boolean) => void;
};

const PriceUnitSelection = ({
  selectedCategory,
  onCategoryChange,
  selectedPriceUnits,
  onPriceUnitsChange,
  setHasError,
}: PriceUnitSelectionProps) => {
  const isCategorySelected = !!selectedCategory;

  return (
    <>
      <PriceUnitCategoryDropdown
        selectedValue={selectedCategory}
        onChange={(value) => {
          onCategoryChange(value);
          if (value) onPriceUnitsChange([]);
        }}
      />
      <CombinedCombobox<PriceUnitDto>
        label="Planning price lists"
        useFilteredItems={useFilteredPriceUnits}
        useItemsPasting={usePriceUnitsPasting}
        selectedItems={selectedPriceUnits}
        onSelect={(selected: MultiValue<DefaultOptionType>) =>
          onPriceUnitsChange([...selected])
        }
        setHasError={setHasError}
        isDisabled={isCategorySelected}
      />
    </>
  );
};

export default PriceUnitSelection;
